import FeatureCard from "../../../common/feature-card/FeatureCard";
import { useTranslation } from "react-i18next";
import { svgs } from "../../../../core/constants/svgs";

const ToolChoice = ({
  tools = [],
  onSelect,
  selectedOption,
  isVisible = true,
}) => {
  const { t } = useTranslation();
  const key = "book_start_choice";

  return (
    <div
      style={
        isVisible
          ? { height: "auto", visibility: "visible" }
          : { height: "0px", visibility: "hidden" }
      }
    >
      <div className="row justify-content-center mb-4" key={`${key}-group`}>
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-6 mb-3">
            <h4 className="section-desc">
              {t("tool_choice.which_tool_you_need")}
            </h4>
          </div>
          <div className="col-lg-8 col-md-6" />
        </div>

        {tools.map((item, index) => {
          const icon =
            item.icon_key && svgs[item.icon_key] ? svgs[item.icon_key] : null;
          return (
            <FeatureCard
              key={`${key}-${index}`}
              onClick={() => onSelect(item.id)}
              img={icon}
              name={item.name}
              description={item.description}
              is_selected={selectedOption === item.id}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ToolChoice;
